module.exports = __webpack_public_path__ + "public/img/gx.ef3b2cc9.png";